// Module
var code = `<form name="\$ctrl.formName" novalidate>
    <div class="alert-container">
      <div class="alert" ng-if="\$ctrl.warningMessage">
        {{\$ctrl.warningMessage}}
        <button type="button" class="close" ng-click="\$ctrl.closeAlert()">&times;</button>
      </div>
    </div>

    <div class="override-option">
      <div class="override-checkbox">
        <div ng-if="\$ctrl.overrideRequired" class="label">Override charges</div>
        <div ng-if="\$ctrl.overrideRequired">
          <input ng-model="\$ctrl.overrideChkbox"
               ng-change="\$ctrl.overrideChkboxChange()"
               type="checkbox"
               ng-disabled="!\$ctrl.isEditModeEnabled() || (!\$ctrl.overrideChkbox && !\$ctrl.canEnableFeeOverride())">
        </div>
      </div>
      <button type="button"
              ng-click="\$ctrl.recalculateDefaultAndCustomFees()"
              ng-if="\$ctrl.isEditModeEnabled() && \$ctrl.recalculationRequired"
              class="btn btn-warning">
        Recalculate
      </button>
    </div>

    <div ng-if="\$ctrl.overrideChkbox  || \$ctrl.modificationMode === true">
      <div class="show-zero-checkbox">
        <div  class="label">Show fees with 0 calculated value</div>
        <div >
          <input ng-model="\$ctrl.showZeroValues"
                 type="checkbox">
        </div>
      </div>
      <div class="alert-container">
        <div class="alert alert--info" ng-if="\$ctrl.loanProduct.interestType === 'ADD_ON_RATE' && (\$ctrl.loanProduct.defaultPastDueMaturityToInterestRate || \$ctrl.loanProduct.defaultPastDueToInterestRate)">
          For add-on rate loans: defaulted Past Due Interest rates are based on effective interest rate and will be updated during simulation.
          <button type="button" class="close" ng-click="\$ctrl.closeAlert()">&times;</button>
        </div>
      </div>
      <h2>Normal fees</h2>
      <table class="table">
        <thead>
          <th>Name</th>
          <th>Standard</th>
          <th>Difference</th>
          <th>Override</th>
          <th>Override percentage</th>
          <th>Already paid</th>
        </thead>
        <tbody ng-repeat="fee in \$ctrl.allFees">
            <tr ng-if="\$ctrl.feeVisibility[fee.key]" ng-show="\$ctrl.defaultFees[fee.key] > 0 || \$ctrl.showZeroValues">
              <td>{{fee.name}}</td>
              <td>
                <cash value="\$ctrl.defaultFees[fee.key]"
                  ng-disabled="true"></cash>
              </td>
              <td>
                <cash value="\$ctrl.diff[fee.key]"
                  ng-disabled="true"></cash>
              </td>
              <td>
                <cash ng-change="\$ctrl.diffCalculate(fee.key)"
                  ng-model="\$ctrl.loan.feeOverride[fee.key]"
                  min="0"
                  ng-required="true"
                  ng-disabled="!\$ctrl.isEditModeEnabled()"></cash>
              </td>
              <td></td>
              <td>
                <input type="checkbox"
                       ng-model="\$ctrl.loan.feeOverride[fee.key + 'AlreadyPaid']"
                       ng-if="\$ctrl.isPaidUpfrontAllowed(fee)"/>
              </td>
            </tr>
          </tbody>
          <tbody ng-repeat="fee in \$ctrl.filterNonFormulaFees(\$ctrl.loan.customFeesOverride)">
            <tr ng-if="\$ctrl.customFeeVisibility[fee.feeDefinitionId]" ng-show="fee.defaultAmount > 0 || \$ctrl.showZeroValues">
              <td>{{\$ctrl.getCustomFeeName(fee)}}</td>
              <td>
                <cash value="fee.defaultAmount"
                  ng-disabled="true"></cash>
              </td>
              <td>
                <cash value="fee.amount - fee.defaultAmount"
                  ng-disabled="true"></cash>
              </td>
              <td>
                <cash ng-model="fee.amount"
                      min="0"
                      ng-required="true"
                      ng-change="\$ctrl.amountChanged()"
                      ng-disabled="!\$ctrl.isEditModeEnabled() || fee.overridePercentage || fee.feeAmortizationType === 'EQUALLY_CYCLIC'"></cash>
              </td>
              <td>
                <input type="checkbox"
                       ng-disabled="fee.feeType !== 'PERCENTAGE'"
                       ng-model="fee.overridePercentage"/>
              </td>
              <td>
                <input type="checkbox"
                       ng-if="fee.applyOn === 'LOAN_RELEASE'"
                       ng-model="fee.paidUpfront"/>
                 <help ng-if="\$ctrl.shouldAlwaysIncludeOnDiscountCharges(fee)" title="Amount will still be included on discount charges calculation"/>
              </td>
            </tr>
            <tr ng-if="\$ctrl.customFeeVisibility[fee.feeDefinitionId] && fee.feeType === 'PERCENTAGE' && fee.overridePercentage">
              <td></td>
              <td>
                <glue-container append-percentage="true">
                  <input type="number"
                         ng-model="fee.defaultPercentage"
                         ng-disabled="true">
                </glue-container>
              </td>
              <td>
                <glue-container append-percentage="true">
                  <input type="number"
                         ng-value="fee.percentage - fee.defaultPercentage"
                         ng-disabled="true">
                </glue-container>
              </td>
              <td>
                <glue-container append-percentage="true">
                  <input type="number"
                         ng-model="fee.percentage"
                         ng-required="true"
                         ng-disabled="!\$ctrl.isEditModeEnabled()"
                         ng-change="\$ctrl.percentageChanged(fee)">
                </glue-container>
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tbody>
          <tr>
            <td>Past due interest rate:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.loanProduct.pastDueInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
            <td></td>
            <td>
              <charge
                disable-rate="!\$ctrl.isEditModeEnabled() || \$ctrl.loanProduct.defaultPastDueToInterestRate"
                disable-type="!\$ctrl.isEditModeEnabled() || \$ctrl.loanProduct.defaultPastDueToInterestRate"
                charge="\$ctrl.loan.pastDueInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Past due maturity interest rate:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.loanProduct.pastDueMaturityInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
            <td></td>
            <td>
              <charge
                disable-rate="!\$ctrl.isEditModeEnabled() || \$ctrl.loanProduct.defaultPastDueMaturityToInterestRate"
                disable-type="!\$ctrl.isEditModeEnabled() || \$ctrl.loanProduct.defaultPastDueMaturityToInterestRate"
                charge="\$ctrl.loan.pastDueMaturityInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.loanProduct.penaltyDisplayOnProductCreation">
            <td>Penalty:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.penalty"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
            <td></td>
            <td>
              <charge
                disable-rate="!\$ctrl.isEditModeEnabled() || \$ctrl.penaltyDef.extraOptions.LOAN_BOARD"
                disable-type="!\$ctrl.isEditModeEnabled() || \$ctrl.penaltyDef.extraOptions.LOAN_BOARD"
                charge="\$ctrl.loan.penalty"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.loanProduct.penaltyMaturityDisplayOnProductCreation">
            <td>Penalty maturity:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.loanProduct.penaltyMaturity"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
            <td>
              <!-- need this to keep upper table width -->
              <cash class="invisible"></cash>
            </td>
            <td>
              <charge
                disable-rate="!\$ctrl.isEditModeEnabled()"
                disable-type="!\$ctrl.isEditModeEnabled()"
                charge="\$ctrl.loan.penaltyMaturity"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div ng-if="\$ctrl.filterAndSortFormulaFees(\$ctrl.loan.customFeesOverride).length > 0">
        <h2>Formula related fees</h2>
        <table class="table">
          <thead>
          <th>Name</th>
          <th>Standard</th>
          <th>Difference</th>
          <th>Override</th>
          <th>Override percentage</th>
          </thead>
          <tbody ng-repeat="fee in \$ctrl.filterAndSortFormulaFees(\$ctrl.loan.customFeesOverride)">
            <tr ng-if="\$ctrl.customFeeVisibility[fee.feeDefinitionId]" ng-show="fee.defaultAmount > 0 || \$ctrl.showZeroValues">
              <td>
                {{\$ctrl.getCustomFeeName(fee)}}
                <help ng-if="fee.applyOn === 'FORMULA'" title="Not deducted from loan proceeds"/>
              </td>
              <td>
                <cash value="fee.defaultAmount"
                      ng-disabled="true"></cash>
              </td>
              <td>
                <cash value="fee.amount - fee.defaultAmount"
                      ng-disabled="true"></cash>
              </td>
              <td>
                <cash ng-model="fee.amount"
                      min="0"
                      ng-required="true"
                      ng-change="\$ctrl.amountChanged()"
                      ng-disabled="!\$ctrl.isEditModeEnabled() || fee.overridePercentage || fee.feeAmortizationType === 'EQUALLY_CYCLIC'"></cash>
              </td>
              <td>
                <input type="checkbox"
                       ng-disabled="fee.feeType !== 'PERCENTAGE'"
                       ng-model="fee.overridePercentage"/>
              </td>
            </tr>
            <tr ng-if="\$ctrl.customFeeVisibility[fee.feeDefinitionId] && fee.feeType === 'PERCENTAGE' && fee.overridePercentage">
              <td></td>
              <td>
                <glue-container append-percentage="true">
                  <input type="number"
                         ng-model="fee.defaultPercentage"
                         ng-disabled="true">
                </glue-container>
              </td>
              <td>
                <glue-container append-percentage="true">
                  <input type="number"
                         ng-value="fee.percentage - fee.defaultPercentage"
                         ng-disabled="true">
                </glue-container>
              </td>
              <td>
                <glue-container append-percentage="true">
                  <input type="number"
                         ng-model="fee.percentage"
                         ng-required="true"
                         ng-disabled="!\$ctrl.isEditModeEnabled()"
                         ng-change="\$ctrl.percentageChanged(fee)">
                </glue-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/charges-override/customer-loan-charges-override.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;